import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { toggleDebugMode, enableFeature } from './debugSlice';
import { useDebriefDispatch } from 'ff/debrief/hooks';

const useDebugUrlMonitor = () => {
    const dispatch = useDebriefDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const debugParam = searchParams.get('debug');
        const featuresParam = searchParams.get('features');

        if (debugParam === 'true') {
            dispatch(toggleDebugMode());

            if (featuresParam) {
                const features = featuresParam.split(',');
                features.forEach(feature =>
                    dispatch(enableFeature(feature.trim()))
                );
            }

            // Remove debug params from URL without navigation
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('debug');
            newParams.delete('features');
            setSearchParams(newParams, { replace: true });
        }

        if (debugParam === 'false') {
            dispatch(toggleDebugMode());

            // Remove param from URL
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('debug');
            setSearchParams(newParams, { replace: true });
        }
    }, [searchParams, dispatch, setSearchParams]);
};

export default useDebugUrlMonitor;

// Usage:
// /?debug=true&features=debrief
